module.exports = __webpack_public_path__ + "static/media/bts_boots_170812_007_small.00019ef5.jpg";